import { render, staticRenderFns } from "./servierDetail.vue?vue&type=template&id=16c47138&scoped=true"
import script from "./servierDetail.vue?vue&type=script&lang=js"
export * from "./servierDetail.vue?vue&type=script&lang=js"
import style0 from "./servierDetail.vue?vue&type=style&index=0&id=16c47138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c47138",
  null
  
)

export default component.exports